export enum RouterNames {
  Home = 'home',
  Details = 'details',
  Gallery = 'gallery',
  Login = 'login',
  NotFound = 'not-found',
}
